module.exports = __webpack_public_path__ + "static/vakif-yeni-1-2285e5e3c46b51d643462af148755cee.png";